import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UtilFns } from './util-fns';
import { DialogBaseComponent, DialogParams } from './dialog-base.component';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DomainService } from './domain.service';

export interface FileViewDialogParams extends DialogParams {
  header: string;
  files?: File[];
  docs?: IDoc[];
  deleteFn?: (IDoc) => boolean;
}

export interface IDoc {
  doc: any;
  mimeType: string;
  fileName: string;
}

// /** Convert encoded string into byte array for File or Blob */
// export const stringToByteArray = (s: string): Uint8Array => {
//   const byteCharacters = atob(s);
//   const byteNumbers = new Array(byteCharacters.length);
//   for (let i = 0; i < byteCharacters.length; i++) {
//     byteNumbers[i] = byteCharacters.charCodeAt(i);
//   }
//   const byteArray = new Uint8Array(byteNumbers);
//   return byteArray;
// }



@Component({
    templateUrl: './file-view-dialog.component.html',
    standalone: false
})
export class FileViewDialogComponent  extends DialogBaseComponent<FileViewDialogParams> implements  OnDestroy {

  blobUrl: string;
  safeUrl: SafeResourceUrl;
  fileName: string;
  index: number;
  type: 'img'|'pdf'|'txt'|'other';
  files: File[];

  constructor(
      public config: DynamicDialogConfig<any>,
      public dialogRef: DynamicDialogRef,
      public domainService: DomainService,
      private readonly sanitizer: DomSanitizer
    ) {
      super(config, dialogRef, domainService);
      Object.assign(this.config, {
        width: '90vw',
        height: '95vh'
      });
      this.prepare();
    }

  async prepare() {
    
    this.index = 0;
    if (this.params.docs != null && this.params.docs.length > 0) {
      this.files = this.params.docs.map( d => {
        const byteArray = UtilFns.stringToByteArray(d.doc);
        const file = new File([byteArray], d.fileName, { type: d.mimeType });
        return file;
      });
    } else if (this.params.files) {
      this.files = this.params.files;
    } else {
      // can't put a dialog up here so don't bother
      this.dialogRef.close(null);
      return;
    }
    this.isPageReady = true;
    this.showFile();
  }

  ngOnDestroy(): void {
    this.clearUrl();
  }

  hasNext(): boolean {
    return this.index < this.files.length - 1;
  }

  hasPrev(): boolean {
    return this.index > 0 && this.files.length > 0;
  }

  next(): void {
    if (this.hasNext()) {
      this.index++;
      this.showFile();
    }
  }

  prev(): void {
    if (this.hasPrev()) {
      this.index--;
      this.showFile();
    }
  }

  async deleteDoc(): Promise<boolean> {
    const doc = this.params.docs && this.params.docs[this.index];
    if (doc && this.params.deleteFn) {
      const yes = await this.domainService.dialogService.yesNoDialog('Delete Document', `Do you want to delete ${doc.fileName} ?`);
      if (yes) {
        if (this.params.deleteFn(doc)) {
          this.files.splice(this.index, 1);
          if (this.index >= this.files.length && this.index > 0) {
            this.index--;
          }
          this.showFile();
          return true;
        }
      }
    }
    return false;
  }

  private showFile() {
    this.clearUrl();
    const file = this.files[this.index];
    if (file) {
      this.setFileType(file);
      this.blobUrl = URL.createObjectURL(file);
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
      this.fileName = file.name;
    }
  }

  private setFileType(file: File) {
    if (file.type.endsWith('pdf')) {
      this.type = 'pdf';
    }
    else if (file.type.startsWith('image')) {
      this.type = 'img';
    }
    else if (file.type == 'text/plain' || file.type == 'text/html') {
      this.type = 'txt';
    }
    else {
      this.type = 'other';
    }
  }

  private clearUrl() {
    this.type = null;
    if (this.blobUrl) {
      this.safeUrl = null;
      URL.revokeObjectURL(this.blobUrl);
    }
  }

  close() {
    this.clearUrl();
    this.dialogRef.close(null);
  }

}
